import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import Moment from 'react-moment';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './Store';

Moment.startPooledTimer();

const Root = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

ReactDOM.render(<Root />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
